
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import JobList from '../components/List.vue'
import AssignmentReportModal from '../components/AssignmentReportModal.vue'

@Component({
  components: { JobList, AssignmentReportModal }
})
export default class JobListPage extends Vue {
  get assignmentReportModal() {
    return this.$refs.assignmentReportModal as AssignmentReportModal
  }

  get isTranslationAgency () {
    return this.$store.getters['auth/isTranslationAgency']
  }

  get isMigrationAgency () {
    return this.$store.getters['auth/isMigrationAgency']
  }

  downloadAssignmentReport() {
    this.assignmentReportModal.open()
  }
}
